import React from "react";
import style from "./Loader.module.scss";

const Loader = () => {
  return <div className={style.loader}></div>;
};

export default Loader;
